<template>
   <v-layout align-start>
      <v-flex xs12>
         <v-snackbar v-model="snackbar" :color="snackColor" :right="true" :bottom="true" :timeout="4000">
            {{ snackText }}
            <template #action="{ attrs }">
               <v-btn color="white" text v-bind="attrs" @click="snackbar = false">Cerrar</v-btn>
            </template>
         </v-snackbar>

         <v-card elevation="0">
            <v-toolbar color="primary" dark>
               <v-toolbar-title style="font-weight:500">Administración de asesores — Planes de Pago</v-toolbar-title>
               <v-spacer></v-spacer>
            </v-toolbar>

            <v-card-text class="text--primary pa-6">

               <!-- Selección de modo -->
               <div class="subtitle-2 font-weight-bold mb-1">Modo de asignación</div>
               <div class="caption grey--text mb-4">Selecciona cómo se distribuyen automáticamente las nuevas solicitudes entre los asesores.</div>

               <v-row class="mb-2">
                  <v-col cols="12" sm="4" v-for="m in modos" :key="m.id">
                     <v-card
                        outlined
                        class="modo-card"
                        :class="{ 'modo-activo': modoSeleccionado === m.id }"
                        @click="modoSeleccionado = m.id"
                        style="cursor:pointer; height:100%"
                     >
                        <!-- Header de la tarjeta -->
                        <div
                           class="modo-header d-flex align-center px-4 py-3"
                           :class="modoSeleccionado === m.id ? 'modo-header-activo' : 'modo-header-inactivo'"
                        >
                           <v-icon small :color="modoSeleccionado === m.id ? 'white' : 'grey darken-1'" class="mr-2">{{ m.icono }}</v-icon>
                           <span class="font-weight-bold body-2" :class="modoSeleccionado === m.id ? 'white--text' : 'grey--text text--darken-2'">
                              {{ m.nombre }}
                           </span>
                           <v-spacer></v-spacer>
                           <v-icon v-if="modoSeleccionado === m.id" color="white" small>fa-check-circle</v-icon>
                        </div>

                        <!-- Cuerpo: tagline + reglas -->
                        <div class="px-4 py-3">
                           <div class="caption font-weight-medium grey--text text--darken-2 mb-3">{{ m.tagline }}</div>
                           <div v-for="(r, i) in m.reglas" :key="i" class="d-flex align-start mb-2">
                              <v-icon :color="r.color" x-small class="mr-2 mt-1">{{ r.icono }}</v-icon>
                              <span class="caption grey--text text--darken-3" style="line-height:1.4">{{ r.texto }}</span>
                           </div>
                        </div>
                     </v-card>
                  </v-col>
               </v-row>

               <v-btn color="primary" :loading="guardandoModo" @click="guardarModo" class="mb-6 mt-2">
                  <v-icon left small>fa-save</v-icon> Guardar modo
               </v-btn>

            </v-card-text>
         </v-card>
      </v-flex>
   </v-layout>
</template>

<script>
import axios from 'axios'
import { authComputed } from '../helpers'

export default {
   name: 'AdminAsesores',
   mixins: [],
   data: () => ({
      cargando: false,
      guardandoModo: false,
      snackbar: false,
      snackText: '',
      snackColor: 'primary',

      modoSeleccionado: 1,

      modos: [
         {
            id: 1,
            nombre: 'Por Defecto',
            icono: 'fa-layer-group',
            tagline: 'Separación estricta por nivel de complejidad',
            reglas: [
               { icono: 'fa-exclamation-circle', color: 'orange darken-2', texto: 'Alumnos con deuda acumulada de ciclos anteriores - Asesor nivel 2 (casos especiales)' },
               { icono: 'fa-user-check',         color: 'primary',         texto: 'Solicitudes nuevas normales - Asesores nivel 1 en recepción' }
            ]
         },
         {
            id: 2,
            nombre: 'Equitativa',
            icono: 'fa-balance-scale',
            tagline: 'Distribución balanceada entre todos los asesores',
            reglas: [
               { icono: 'fa-exclamation-circle', color: 'orange darken-2', texto: 'Alumnos con deuda acumulada de ciclos anteriores - Asesor nivel 2 (casos especiales)' },
               { icono: 'fa-users',              color: 'primary',         texto: 'Solicitudes nuevas normales - Asesores de Nivel 1 y 2 se asignaran equitativamente' }
            ]
         }
      ]
   }),
   computed: {
      ...authComputed
   },
   created() {
      if (this.permController(25, 'ver')) {
         this.init()
      } else {
         this.$router.push({ name: 'inicio' })
      }
   },
   methods: {
      async init() {
         this.cargando = true
         try {
            const modoRes = await axios.get('api/AdminAsesores/modo')
            this.modoSeleccionado = parseInt(modoRes.data)
         } catch {
            this.mostrarSnack('Error al cargar la configuración.', 'snackError')
         } finally {
            this.cargando = false
         }
      },

      async guardarModo() {
         this.guardandoModo = true
         try {
            await axios.put(`api/AdminAsesores/modo?value=${this.modoSeleccionado}`)
            this.mostrarSnack('Modo de asignación guardado.', 'primary')
         } catch {
            this.mostrarSnack('Error al guardar el modo.', 'snackError')
         } finally {
            this.guardandoModo = false
         }
      },

      mostrarSnack(texto, color) {
         this.snackText  = texto
         this.snackColor = color
         this.snackbar   = true
      }
   }
}
</script>

<style scoped>
.modo-card {
   border: 2px solid #e0e0e0 !important;
   border-radius: 8px !important;
   transition: border-color 0.2s, box-shadow 0.2s;
}
.modo-card:hover {
   border-color: #bdbdbd !important;
   box-shadow: 0 2px 6px rgba(0,0,0,0.08) !important;
}
.modo-activo {
   border-color: #6C1C19 !important;
   box-shadow: 0 3px 10px rgba(108, 28, 25, 0.18) !important;
}
.modo-header {
   border-radius: 6px 6px 0 0;
}
.modo-header-activo {
   background-color: #6C1C19;
}
.modo-header-inactivo {
   background-color: #f5f5f5;
}
</style>
